import * as React from 'react';
import { styles } from './styles';

interface ModalHeaderProps {
  children: React.ReactNode;
  title: React.ReactNode;
  hideExitButton?: boolean;
  centered?: boolean;
}

export const ModalHeader: React.SFC<RequireOnlyOne<ModalHeaderProps, 'children' | 'title'>> = ({
  children,
  title,
  centered
}) => {
  return <div className={styles.container(centered)}>{children ? <div>{children}</div> : <h3>{title}</h3>}</div>;
};
